<ng-container *ngIf="subUsers$ | async as subUsers; else loadingContent">
  <app-sub-users-table [subUsers]="subUsers.data ?? []"></app-sub-users-table>
</ng-container>

<ng-template #loadingContent>
  <app-loader></app-loader>
</ng-template>
